import { CartesianGrid, Legend, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { ForecastMonthPoint } from '@app/shared';
import { formatCents } from '@/lib/format';

export function PrevisionChart({ months, currency }: { months: readonly ForecastMonthPoint[]; currency: string }) {
  const hasBalance = months.some((month) => month.cumulativeBalanceCents !== null);
  const data = months.map((month) => ({
    mois: month.monthStart,
    net: month.netCents / 100,
    solde: month.cumulativeBalanceCents === null ? null : month.cumulativeBalanceCents / 100,
  }));

  return (
    <div className="h-72 w-full">
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
          <XAxis dataKey="mois" tick={{ fontSize: 12 }} />
          <YAxis
            tick={{ fontSize: 12 }}
            tickFormatter={(value: number) => formatCents(Math.round(value * 100), currency)}
            width={90}
          />
          <Tooltip formatter={(value) => formatCents(Math.round(Number(value) * 100), currency)} />
          <Legend />
          <ReferenceLine y={0} stroke="var(--color-border)" />
          <Line type="monotone" dataKey="net" name="Flux net mensuel" stroke="var(--color-primary)" strokeWidth={2} dot={false} />
          {hasBalance && (
            <Line
              type="monotone"
              dataKey="solde"
              name="Solde cumulé"
              stroke="var(--color-destructive)"
              strokeWidth={2}
              dot={false}
              connectNulls={false}
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
